import React from "react";
import { useTranslation } from "react-i18next";
import loading from './images/loading.gif'
import ChrysanthemumIcon from "./icon/chrysanthemum.svg";
import HKJCTV from "./icon/HKJCTV.svg";
import Member_loading from "./icon/member_loading.svg";
import LoadingLogo from "/login/images/loading.gif"
import refresh_loading from "./images/refresh_loading.gif";
import { getLocationParamer } from "@/utils/common";
import './index.scss'
const appType = getLocationParamer("appType");

export const mobileType= ()=> {
    switch (appType) {
        case 'Racing':
            return 'ringRacing'
        case 'HKJCTV':
            return 'ringHKJCTV'
        default:
            return 'ThreeInOne'
    } 
}
const Loading = ({isShowLoading,type = 'default', className})=>{
    const { t } = useTranslation();
    const  isMemberApp = window.location.pathname.includes("/member") && window?.MBSSClient;
   return isShowLoading && <div className={`loading-wapper loading-wapper-${type} ${className || ''}`}>
    {type ==='line' && <div className="loading-Layer_content__SDN4F"><img className="loading-Layer_loader__HnAe8" src={loading} alt=""/></div>}
    {type ==='dot' && <div className="loading-dot-wrapper" id="loading-dot-wrapper"><div className="loading-dot remove" id="loading-dot"><div></div><div></div><div></div><div></div></div></div>}
    {type ==='ring' && <div className="content-loader"><img className="load" src={LoadingLogo} alt="" /></div>  }
    {type ==='ringRacing' && <div className="content-loader"><img className="load" src={refresh_loading} alt="" /></div>  }
    {type ==='ringHKJCTV' && <div className="content-loader"><HKJCTV className="HKJCTVIcon"></HKJCTV></div>  }
    {type ==='member' && 
        <div className={`memberIcon ${isMemberApp ? 'isApp' : ''}`}>
            <Member_loading  width={51} height={64}></Member_loading>
        </div>
    }
    {(type ==='default' || type ==='ThreeInOne') && <div className="loading-chrysanthemum"><ChrysanthemumIcon></ChrysanthemumIcon><div>{t('LOADING')}</div></div>}
   </div>
        
}

export default Loading;